const gap = {
    name: "gap",
    path: "/gap",
    title: "gap",
    description: "Utilities for controlling the size of implicitly-created grid rows.",
    value: {
        "gap": {
            "gap-<number>": "calc(var(--1) * <number>)",
            "gap-[<value>]": "<value>",
            'gap-px': '1px',
        },
        "column-gap": {
            "gap-x-<number>": "calc(var(--1) * <number>)",
            "gap-x-[<value>]": "<value>",
            'gap-x-px': '1px',
        },
        "row-gap": {
            "gap-y-<number>": "calc(var(--1) * <number>)",
            "gap-y-[<value>]": "<value>",
            'gap-y-px': '1px',
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-columns-2 gap-4">
  <div>01</div>
  <div>02</div>
  <div>03</div>
  <div>04</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="grid grid-columns-3 gap-x-8 gap-y-4">
  <div>01</div>
  <div>02</div>
  <div>03</div>
  <div>04</div>
  <div>05</div>
  <div>06</div>
</div>      `
            },
        },
        {
            "example": {
                "code": `
<div class="gap-[50px] ...">
  <!-- ... -->
</div>      `
            },
        }
    ],
     htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">gap-<var>&lt;number&gt;</var></code>
                  utilities like gap-2 and gap-4 to change the gap between both rows and columns in grid and flexbox layouts:
            </p>

            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid grid-columns-2 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>                </div>
            </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">gap-x-<var>&lt;number&gt;</var>, gap-y-<var>&lt;number&gt;</var></code>
                  utilities like gap-x-8 and gap-y-4 to change the gap between columns and rows independently:
            </p>

              <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid grid-columns-2 gap-x-8 gap-y-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>  
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">05</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">gap-[<value>], gap-x-[<value>], gap-y-[<value>]</code>
                  syntax to set the columns based on a completely custom value:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid grid-columns-2 gap-[50px] font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>                </div>
            </div>
            `
        },
    ]
};



export default gap;

<div className="sr-only md:grid-columns-4 gap-[50px] gap-x-8 gap-y-4 grid-columns-2 grid-columns-[200px_minmax(150px,_1fr)_100px] grid-columns-4 col-span-3 col-start-2  grid-columns-subgrid bg-color-blue-200">



</div>